export const CONTACTS_BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api/contacts-management`;
export const LOOKUP_CONTACT_ROLE = `${CONTACTS_BASE_URL}/list-contact-role`;

export const CONTACT_PK_FIELD = "contact_ndx";

export const COLUMNS = [
  {
    field: "contact_ndx",
    headerName: "Contact",
    width: 80,
    editable: false,
    type: "number",
  },
  {
    field: "name_company",
    headerName: "Company Name",
    width: 200,
    editable: true,
  },
  { field: "name_last", headerName: "Last Name", width: 150, editable: true },
  { field: "name_first", headerName: "First Name", width: 150, editable: true },
  {
    field: "role_ndx",
    headerName: "Role",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "address",
    headerName: "Address",
    width: 220,
    editable: true,
  },
  {
    field: "city",
    headerName: "City",
    width: 150,
    editable: true,
  },
  {
    field: "state",
    headerName: "State",
    width: 70,
    editable: true,
  },
  {
    field: "zip_code",
    headerName: "Zip Code",
    width: 90,
    editable: true,
  },
  {
    field: "phone_primary",
    headerName: "Primary Phone",
    width: 150,
    editable: true,
  },
  {
    field: "phone_alternate",
    headerName: "Alternate Phone",
    width: 150,
    editable: true,
  },
  { field: "phone_fax", headerName: "Fax", width: 150, editable: true },
  { field: "email", headerName: "Email", width: 200, editable: true },
  {
    field: "num_tceq",
    headerName: "TCEQ Number",
    width: 150,
    editable: true,
    type: "number",
  },
  {
    field: "num_license",
    headerName: "License Number",
    width: 150,
    editable: true,
  },
];
